import { useSEO } from "../../hooks/useSEO";

const Disclaimer = () => {
  useSEO({
    title: "Disclaimer",
    description: "Important disclaimer: TaxShift 2026 is for educational purposes only and does not constitute tax, legal, or financial advice.",
    path: "/disclaimer",
  });

  return (
    <div className="py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="font-mono uppercase text-[10px] tracking-[0.3em] text-muted-foreground mb-4 block">
          Compliance · Disclaimer
        </span>
        <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-3">Disclaimer</h1>
        <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-10 pb-6 border-b-2 border-foreground">
          Last updated: February 2026
        </p>
        <div className="font-body text-base leading-relaxed space-y-5 text-foreground/85">
          <div className="border-2 border-destructive p-5 bg-destructive/5">
            <p className="font-semibold">
              TaxShift 2026 is an educational website. Nothing on this site constitutes tax advice,
              legal advice, accounting advice, or financial advice.
            </p>
          </div>
          <h2 className="font-heading text-2xl font-semibold mt-8">Illustrative calculations only</h2>
          <p>
            Our calculators produce projections based on the actual federal tax law as amended by
            the One Big Beautiful Bill Act (OBBBA), Public Law 119-21, signed July 4, 2025. They
            use simplified assumptions (e.g., no state tax, no AMT interaction in most calculators,
            no complex credit interactions beyond CTC, no PTC reconciliation, no self-employment
            tax). Real-world tax outcomes depend on many factors our calculators do not model.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">OBBBA made TCJA permanent</h2>
          <p>
            The calculators reflect current, enacted law. OBBBA permanently extended most TCJA
            individual provisions (including the seven-bracket rate structure, the near-doubled
            standard deduction, the permanent elimination of personal exemptions, the $2,200
            Child Tax Credit, the 20% Section 199A QBI deduction, and the $15M estate/gift
            exemption), and added several temporary deductions (No Tax on Tips, No Tax on Overtime,
            Senior $6,000 Deduction, Auto Loan Interest — generally available 2025-2028). Future
            IRS inflation adjustments will update annual figures; we update our calculators as
            those Revenue Procedures are published.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">No professional relationship</h2>
          <p>
            Using this site does not create a CPA-client, attorney-client, or financial advisor-client
            relationship. Always consult a qualified tax professional, CPA, enrolled agent, attorney,
            or licensed financial advisor for advice specific to your situation.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">Affiliate and advertising disclosure</h2>
          <p>
            The Service is supported by contextual advertising, primarily Google AdSense. We do not
            have affiliate relationships with tax-preparation software or tax-advisory firms at the
            time of publication, but this may change; material affiliate relationships will be
            disclosed.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">No guarantees</h2>
          <p>
            We do not guarantee the accuracy, completeness, or timeliness of the information
            provided. Use is at your own risk.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
